import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { interceptor } from "utils/interceptor";
import { Layout } from "antd";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { generateUUID } from "utils/appUtil";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { RootState } from "reducers/rootReducer";
import  useSocketNetworkLayer  from '../../services/socketNetworkLayer'
import  SurveyListModal  from '../../components/Modals/Survey/SurveyListModal'
import  Dashboard  from '../../components/Modals/911/Dashboard'
import  InstoreDashboard  from '../../components/Modals/Instore/Dashboard'
import  RideDashboard  from '../../components/Modals/Ride/Dashboard'
import  RideWrapper  from '../../components/Modals/Ride/RideWrapper'
import  RideWrapper2  from '../../components/Modals/Ride/RideWrapper2'
import  CPCDashboard  from '../../components/Modals/CPC/Dashboard'
import  CalendarDashboard  from '../../components/Modals/Calendar/Dashboard'
import  CustomerCPCDashboard  from '../../components/Modals/Customer-CPC/Dashboard'
import  AnalyticsSummaryModal  from '../../components/Modals/Summary/AnalyticsSummaryModal'
import  RideSummaryModal  from '../../components/Modals/RideSummary/RideSummaryModal'
import  DashboardWrapper  from '../../components/Modals/Dashboard/DashboardWrapper'
import  CallCenterModal  from '../../components/Modals/CallCenter/CallCenterModal'
import  PaymentModal  from '../../components/Modals/Payment/PaymentModal'


import useLocalStorageService from "../../services/localStorage"
import {UUID , TOKEN} from "../../constants/localStoreKeys";
import CADFormModal from "../../components/Modals/CAD/CADFormModal";
import CustomerFormModal from "../../components/Modals/Customer/CADFormModal";
import  BioDashboard  from '../../components/Modals/BioForm/Dashboard'

const stripeKey: string = process.env.REACT_APP_STRIPE_KEY || "";

const stripePromise = loadStripe(stripeKey);

const { Header, Content, Footer } = Layout;

export default () => {
  const history = useHistory();
  const [isLoggedIn, setLoggedIn] = useState<boolean>();

  const socket = useSocketNetworkLayer();
  const {getLocalStorageItem, setLocalStorageItem} = useLocalStorageService();


  useEffect(() => {
     socket.connect();
  }, []);

  interceptor();

  return (
    <Elements stripe={stripePromise}>
      <Layout>
        <Content className="site-layout">
          <Switch>
            <Route
              path="/survey"
              render={(props) => <SurveyListModal {...props} socket={socket} onClose={() => (false)} />}
            />
            <Route
              path="/911"
              render={(props) => <Dashboard {...props} socket={socket} />}
            />
            <Route
              path="/payment"
              render={(props) => <PaymentModal {...props} socket={socket} />}
            />
            <Route
              path="/instore"
              render={(props) => <InstoreDashboard {...props} socket={socket} />}
            />
            <Route
              path="/ride"
              render={(props) => <RideWrapper2 {...props} socket={socket} />}
            />
            <Route
              path="/ride2"
              render={(props) => <RideWrapper {...props} socket={socket} />}
            />
            <Route
              path="/ride-dashboard"
              render={(props) => <RideDashboard {...props} socket={socket} />}
            />
            <Route
              path="/call-center"
              render={(props) => <CallCenterModal {...props} socket={socket} />}
            />
            <Route
              path="/cpc"
              render={(props) => <CPCDashboard {...props} socket={socket} />}
            />
            <Route
              path="/calendar"
              render={(props) => <CalendarDashboard {...props} socket={socket} />}
            />
            <Route
              path="/customer-cpc"
              render={(props) => <CustomerCPCDashboard {...props} socket={socket} />}
            />
            <Route
              path="/cad"
              render={(props) => <CADFormModal {...props} socket={socket} />}
            />
            <Route
              path="/customer-cad"
              render={(props) => <CustomerFormModal {...props} socket={socket} />}
            />
            <Route
              path="/summary"
              render={(props) => <AnalyticsSummaryModal {...props} socket={socket} />}
            />
            <Route
              path="/ride-summary"
              render={(props) => <RideSummaryModal {...props} socket={socket} />}
            />
            <Route
              path="/dashboard"
              render={(props) => <DashboardWrapper {...props} socket={socket} />}
            />
           <Route
              path="/bio"
              render={(props) => <BioDashboard {...props} socket={socket} />}
            />
          </Switch>
        </Content>
      </Layout>
    </Elements>
  );
};
